import actions from './actions'
import reducer from './reducer'
import sagas from './sagas'

export default {
  name: 'Authentication',
  actions,
  reducer,
  sagas
}